/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {SideBarMenuComponent} from './side-bar-menu.component';
import {SideBarMenuItemComponent} from './side-bar-menu-item/side-bar-menu-item.component';
import {SideBarMenuItemCollapsedComponent} from './side-bar-menu-item-collapsed/side-bar-menu-item-collapsed.component';
import {TooltipModule} from '../tooltip/tooltip.module';

@NgModule({
    declarations: [
        SideBarMenuComponent,
        SideBarMenuItemComponent,
        SideBarMenuItemCollapsedComponent
    ],
    exports: [
        SideBarMenuComponent,
        SideBarMenuItemComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        TooltipModule
    ]
})
export class SideBarMenuModule {
}
